
.list {
	display: flex;
	flex-wrap: wrap; /* legacy tabs were inline-block, so a long strip wrapped onto a second row */
	border-bottom: 1px solid var(--nav-tabs-border-color);
	margin-bottom: var(--line-height-base); /* 20px — @line-height-computed, the legacy .nav-tabs gap */
}

.tab {
	position: relative; /* anchor for the ::after bar */
	padding: calc(var(--padding-base-y) + 2px) var(--content-padding-base); /* 9px 15px — @nav-link-padding */
	margin-bottom: -1px;
	border: 0;
	background: none;
	font: inherit;
	text-align: inherit;
	font-size: var(--font-size-base);
	line-height: var(--line-height-base);
	color: var(--text-color);
	cursor: pointer;
	transition: color 0.15s ease-in-out;
}

.tab::after {
	content: "";
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	height: 4px; /* a literal in tabNavigation.less, no LESS variable exists */
	background-color: transparent;
	transition: background-color 0.15s ease-in-out;
}

/* `.nav-item.has-error:not(.active) a` — hover still wins, as it does in the theme. */
.tab[data-invalid]:not([data-active]) {
	color: var(--state-danger-text);
}

.tab[data-disabled] {
	color: var(--text-muted);
	cursor: var(--cursor-disabled);
}

.tab:hover:not([data-disabled]) {
	color: var(--color-primary-outline);
}

.tab:focus-visible {
	outline: 2px solid var(--color-primary);
	outline-offset: -2px;
}

/* Base UI 1.6 marks the selected tab `data-active`, not `data-selected`. */
.tab[data-active] {
	color: var(--color-primary-outline);
	cursor: default;
}

.tab[data-active]::after {
	background-color: var(--color-primary-outline);
}

/* for keep mounted */
.panel[hidden] {
	display: none;
}
